const getError = ({ addError }) => async (id: string): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/errors/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: any = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getError };



// WEBPACK FOOTER //
// ./src/modules/errors/_errorsActions.ts